import { CanDeactivateFn } from '@angular/router';

export const canDeactivateGuard: CanDeactivateFn<{
  canDeactivate: () => boolean;
}> = (component) => {
  return component.canDeactivate ? component.canDeactivate() : true;
};
